import Tooltip from "components/Tooltip/Tooltip";
import { getInitialQueryWithTableSettings } from "components/Table/tableUtils";
import { SubrecordTable } from "containers/Resources/screens/ResourcesSingle/components/SubrecordTable";
import { User } from "graphql/generated/graphql";
import { useMemo } from "react";

// localStorage tableSettings key, so the page size persists (parity with other
// record lists). Single non-sortable column: only page size is meaningful.
const userGitPublicKeyListKey = "userGitPublicKeyList";
const userGitPublicKeyInitialQuery = { limit: 10, order: "", offset: 0 };

export type SubrecordTableProps<T> = {
    resourceData: T;
    onResourceClick;
    createSubrecord: () => void;
    fetchResourceData: () => Promise<any>;
    isFieldDisabled?: boolean;
};

export const UserGitPublicKeyList = ({
    resourceData,
    onResourceClick,
    createSubrecord,
    fetchResourceData,
    isOwnUser,
}: SubrecordTableProps<User> & { isOwnUser: boolean }) => {
    const data = useMemo(
        () =>
            resourceData?.user_git_public_key_plain_list_user_id?.map((publicKey) => ({
                ...publicKey,
                resource_type: "user_git_public_key",
            })),
        [resourceData]
    );

    const columns = [
        {
            label: "Public key",
            key: "public_key",
            shown: true,
            sortable: false,
            dto: ({ id, public_key }) => {
                return (
                    <Tooltip
                        overlay={public_key}
                        overlayStyle={{
                            width: "600px",
                            overflowWrap: "anywhere",
                        }}
                    >
                        <span
                            key={id}
                            onClick={(e) =>
                                onResourceClick({
                                    e,
                                    id,
                                    resource_type: "user_git_public_key",
                                })
                            }
                            style={{
                                maxWidth: "600px",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                                display: "block",
                            }}
                        >
                            {public_key}
                        </span>
                    </Tooltip>
                );
            },
        },
    ];

    return (
        <SubrecordTable
            key="userGitPublicKeyList"
            data={data as any[]}
            uniqueKey="userGitPublicKeyList"
            title="Public keys"
            onAddClick={createSubrecord}
            isActionButtonDisabled={resourceData?.deleted_at != null || !isOwnUser}
            refreshData={fetchResourceData}
            columns={columns}
            emptyListText="No public keys."
            recordLabel="public key"
            initialQuery={getInitialQueryWithTableSettings(
                userGitPublicKeyListKey,
                userGitPublicKeyInitialQuery
            )}
            tableSettingsKey={userGitPublicKeyListKey}
            tableOptions={{ viewColumns: true }}
        />
    );
};
